import React from 'react';

import { formatValue } from './promotionsUtils';

/** One old/new value: a short value is an inline colored pill (red = old, green = new); a long/complex
 * one (e.g. a serialized template body) is a muted, horizontally-scrollable block so it never
 * shouts in green or blows out the row width. */
const DiffValue: React.FC<{ value: unknown; tone: 'old' | 'new' }> = ({ value, tone }) => {
  const text = formatValue(value);
  if (text.length > 56) {
    return (
      <span className="block max-w-full overflow-x-auto whitespace-nowrap rounded bg-slate-200 px-4 py-2 text-xs text-slate-900">
        {text}
      </span>
    );
  }
  return <span className={`rounded px-4 ${tone === 'old' ? 'bg-red-100' : 'bg-green-100'}`}>{text}</span>;
};

export default DiffValue;
